import axios from 'axios';
import qs from 'qs';
import { getAuthToken } from '../utils/authUtils';

export async function generateAlbelliEditorUrl({
    locale,
    docId,
    predesignedProductId,
    selectedOptions,
    vpProductKey,
    owner,
    careAgent,
    vpProductName,
    editorEnvironmentOverride,
}) {
    const ownerId = owner;
    const params = qs.stringify({
        ownerId,
        locale,
        docId,
        predesignedProductId,
        selectedOptions: JSON.stringify(selectedOptions),
        vpProductKey,
        careAgent,
        vpProductName,
        editorEnvironmentOverride,
    });

    const result = await axios.get(`${serviceUrlPrefix}api/v1/editorUrl?${params}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${await getAuthToken()}`,
        },
    });
    return result.data.url;
}

export async function getDoc(docId, owner) {
    let url = `${serviceUrlPrefix}api/v1/documents/${docId}?includePreviewImageUrl=false`;
    if (owner) {
        url = `${serviceUrlPrefix}api/v1/documents/${docId}?includePreviewImageUrl=false&ownerId=${owner}`;
    }
    const result = await axios.get(url, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${await getAuthToken()}`,
        },
    });
    if (result.status !== 200) {
        throw new Error('unable to find Doc');
    }
    return result.data;
}

export async function addToCart(queryParams) {
    let result;
    try {
        result = await axios.post(`${serviceUrlPrefix}api/v1/cart?${qs.stringify(queryParams)}`, null, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${await getAuthToken()}`,
            },
        });
    } catch (e) {
        return {
            error: e,
            response: e.response,
        };
    }
    return result.data;
}
